import { isNative } from '@/lib/platform';

/**
 * Open an external URL in the user's default browser.
 *
 * On web, this is `window.open(url, '_blank', 'noopener,noreferrer')`.
 * On Tauri (desktop / mobile), `window.open` is a no-op for external URLs —
 * we route through `@tauri-apps/plugin-opener` so the system browser handles
 * the link. Falls back to `window.open` if the plugin import fails.
 *
 * The Tauri plugin is loaded via dynamic import so web bundles don't pull
 * in the native bridge.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (isNative) {
    try {
      const { openUrl } = await import('@tauri-apps/plugin-opener');
      await openUrl(url);
      return;
    } catch (err) {
      console.warn('[openExternalUrl] plugin-opener failed, falling back to window.open', err);
    }
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
